/**
 * Formats a USD amount for display (PBI #1186).
 */
export function formatUsd(amount: number): string {
  return `$${amount.toFixed(2)}`;
}

/**
 * Formats a USD amount with an optional "from" prefix for catalog tiles.
 */
export function formatUsdFrom(amount: number): string {
  return `from ${formatUsd(amount)}`;
}

/**
 * Formats integer cents as USD; a missing amount renders as an em dash.
 * Admin gift views (PBI #1516) show stored and Goody-reported cents side by side,
 * and Goody's numbers stay null until a quote or billed amount has been saved.
 */
export function formatUsdCents(cents: number | null | undefined): string {
  return cents == null ? '—' : formatUsd(cents / 100);
}
